export const iconFontAwesomeHumanitarianRadio = (
	<i className="fa-solid fa-radio"></i>
);
